import { getAutoCompleteMedications } from '@ctw/shared/api/autocomplete-medications';
import {
  type ComboxboxFieldOption,
  SearchCombobox,
} from '@ctw/shared/components/form/search-combobox';
import { useCTW } from '@ctw/shared/context/ctw-context';
import type { Coding } from 'fhir/r4';
import { type InputHTMLAttributes, useState } from 'react';

export type AutoCompleteComboboxProps = {
  defaultCoding?: Coding;
  readonly: boolean | undefined;
} & InputHTMLAttributes<HTMLInputElement>;

export const MedicationsAutoComplete = ({
  defaultCoding,
  readonly,
  ...inputProps
}: AutoCompleteComboboxProps) => {
  const ctw = useCTW();
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState<Array<ComboxboxFieldOption>>();

  const handleSearchChange = async (query: string) => {
    setIsLoading(true);
    const medications = await getAutoCompleteMedications(ctw, query);

    if (medications) {
      setOptions(
        medications.map((item: Coding) => ({
          value: item,
          label: item.display,
        })) as Array<ComboxboxFieldOption>,
      );
    }

    setIsLoading(false);
  };

  return (
    <SearchCombobox
      options={options || []}
      isLoading={isLoading}
      name={`${inputProps.name}`}
      defaultSearchTerm={inputProps.defaultValue as string}
      readonly={readonly}
      onSearchChange={handleSearchChange}
      defaultValue={defaultCoding}
    />
  );
};
